<template>
	<div>
		<div @click="scanCode()">扫一扫</div>
	</div>
</template>
<style scoped lang="less">
	
</style>
<script>
	
	export default {
		name: 'comparison',
		data:function() {
			return {
				
			}
		},
		mounted: function() {
			var self = this;
			getCommonJsIns.initCSSNEW();
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/comparison/comparison.css?v=12r22e3"
			});
			//确保重要依赖的js加载完成
			getCommonJsIns.initJSNEW(this.webReady);
		},
		methods: {
			webReady: function() {
				$.ajax({
					type:"post",
					url:"/bargain/weiXinAuth/weChat_shareConf",
					data:{"url":window.location.href},
					async:false,
					success:function(data){
							wx.config({
								debug: false,
								appId: data.result.appId, // 必填，公众号的唯一标识
								timestamp: data.result.timestamp, // 必填，生成签名的时间戳
								nonceStr: data.result.nonceStr, // 必填，生成签名的随机串
								signature: data.result.signature,// 必填，签名，见附录1
								jsApiList: ["onMenuShareTimeline","onMenuShareAppMessage","onMenuShareQQ","onMenuShareWeibo","onMenuShareQZone","scanQRCode"]
								//jsApiList: ["onMenuShareTimeline","onMenuShareAppMessage"]
							});
					},
					error:function(jqXHR, textStatus, errorThrown) {
						console.log("errorConfig");
					}
				})

			},
			scanCode:function(){
				wx.scanQRCode({
					needResult : 1,
					scanType : [ "qrCode", "barCode" ],
					success : function(res) {
						//console.log(res)
						alert(JSON.stringify(res));
						var result = res.resultStr;
						window.location.href=result;
					},
					fail : function(res) {
						console.log(res)
						alert(JSON.stringify(res));
		 
					}
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/demo/index.vue